export enum OptimizeOptionsEnum {
  rebalance = 'rebalance',
  contribute = 'contribute',
  redeem = 'redeem'
}
